import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { Apis, Labels } from '../../app.constants';
import {
    CampaignInventoryAtom,
    HeaderDataListAtom,
    // OrganisationListAtom,
    UserMinimalListAtom,
    SupplierPhaseListAtom,
    BookingStatusAtom,
    supplierSearchListAtom,
    filtersCheckBoxAtom,
    finalSupplierListAtom,
    ContactListAtom,
    InventoryListAtom
} from '../../../Services/_states';
import { errorAtom } from '../../../Services/_states';
import SweetAlert from '../../../components/Shared/Notification';
import APIService from '../../../Services/APIService';
import { dateFormate } from '../../../utils/helper';
import { useState } from 'react';

const BookinPlanActions = () => {
    const queryParameters = new URLSearchParams(window.location.search)
    const setErrorAtom = useSetRecoilState(errorAtom);
    const [campaignInventory, setCampaignInventory] = useRecoilState(CampaignInventoryAtom);
    const setHeaderDataList = useSetRecoilState(HeaderDataListAtom);
    const [organisationList,setOrganisationList] = useState([]);
    const setUserMinimalList = useSetRecoilState(UserMinimalListAtom);
    const [supplierPhaseList, setSupplierPhaseList] = useRecoilState(SupplierPhaseListAtom);
    const setBookinStatus = useSetRecoilState(BookingStatusAtom);
    const setSupplierSearch = useSetRecoilState(supplierSearchListAtom)
    const filtersCheckbox = useRecoilValue(filtersCheckBoxAtom);
    const finalSupplierList = useRecoilValue(finalSupplierListAtom);
    const [contactList, setContactList] = useRecoilState(ContactListAtom);
    const setInventoryList = useSetRecoilState(InventoryListAtom)

    const CampaignProposalId = queryParameters.get("campaignId");
    // 'HDFHDF0789';
    // 'TESTESBD56'

    const getCampaignInventories = async (data) => {
        let params = 'page=' + (data.pageNo + 1) + "&supplier_type_code=" + data.supplier_type_code;
        if (data?.booking_status_code) params += '&booking_status_code=' + data?.booking_status_code;
        if (data?.phase_id) params += "&phase_id=" + data?.phase_id;
        if (data?.assigned) params += "&assigned=" + data?.assigned;
        if (data?.start_date && data?.end_date) {
            params += "&start_date=" + dateFormate(data.start_date, 'YYYY-MM-DD') + "&end_date=" + dateFormate(data.start_date, 'YYYY-MM-DD');
        }
        setErrorAtom(true);
        let res = await APIService.get(`v0/ui/website/${CampaignProposalId}/campaign-inventories/?${params}`);
        if (res.status == 200) {
            setCampaignInventory(res.data);
        } else {
            SweetAlert(Labels.Error, 'error');
        }
        setErrorAtom(false);
    };

    const getBookingStatus = async () => {
        let res = await APIService.get(`${Apis.Get_Booking_Status}${CampaignProposalId}`);
        if (res.status == 200) {
            let newList = res.data.map(item => ({ ...item, label: item?.name, value: item?.code }));
            setBookinStatus(newList);
        } else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const getHeaderData = async (data) => {
        let res = await APIService.get(`${Apis.Get_Header_Data}`);
        if (res.status == 200) {
            setHeaderDataList(res.data);
            return res.data.ALL;
        };
    };

    const getRelationShipData = async (data) => {
        let params = "supplier_id=" + data.object_id + "&supplier_code=" + data.supplier_code + "&campaign_id=" + data.proposal;
        let res = await APIService.get(`${Apis.Get_Relationship_Data}${params}`)
        if (res.status == 200) {
            return res.data;
        };
    };

    const getContactDetailsData = async (data) => {
        let params = "supplier_id=" + data?.object_id;
        let res = await APIService.get(`${Apis.Get_Contact_Details}${params}`);
        if (res.status == 200)
            setContactList(res?.data);
        else
            SweetAlert(Labels.Error, 'error');
    };

    const deletContact = async (data) => {
        let res = await APIService.get(`${Apis.Get_Contact_Details}`);
        if (res.status == 200)
            SweetAlert(Labels.Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getCommetByShortlistedId = async (data, type) => {
        let params = `shortlisted_spaces_id=${data?.id}&related_to=${type === "externalComments" ? "EXTERNAL" : "INTERNAL"}`
        let res = await APIService.get(`v0/ui/website/${data?.proposal}/comment/?${params}`);
        if (res.status == 200) return res.data.general;
    }

    const postCommentByShortlistedId = async (data) => {
        let res = await APIService.post(`v0/ui/website/${CampaignProposalId}/comment/`, data);
        if (res.status == 200)
            SweetAlert(res.data, 'error');
        else
            SweetAlert(res.data, 'error');
    }

    const getOrganisationList = async (id) => {
        let res = await APIService.get(`${Apis.Get_Organisation_List}`);
        if (res.status == 200) {
            let newList = res.data.map(item => ({ ...item, label: item?.name, value: item?.organisation_id }));
            setOrganisationList(newList);
        }
        else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const postBrandAssignment = async (data) => {
        let res = await APIService.post(`${Apis.Post_Brand_Assignment}`, data);
        if (res.status == 200)
            SweetAlert("Assigned successfully", 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getUserMinimalList = async () => {
        let res = await APIService.get(`${Apis.getUserMinimalList}`);
        if (res.status == 200) {
            let newList = res.data.map(item => ({ ...item, label: item?.username, value: item?.id }));
            setUserMinimalList(newList)
        }
        else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const postSupplierAssignment = async (data) => {
        let res = await APIService.post(`${Apis.Post_Supplier_Assignment}`, data);
        if (res.status == 200)
            SweetAlert("Assigned successfully", 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getPermissionBoxImages = async (data) => {
        let res = await APIService.get(`${Apis.Get_Permission_Box_Images}?campaign_id=${data?.campaign_id}&supplier_id=${data?.supplier_id}`);
        if (res.status == 200)
            return res.data;
        else
            SweetAlert(Labels.Error, 'error');
    }

    const postPermissionBoxImages = async (file) => {
        let res = await APIService.post(`v0/ui/website/hashtag-images/${CampaignProposalId}/${Apis.Post_permission_Box_Images}`, file, true);
        if (res.status == 200)
            SweetAlert(Labels.Upload_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getReceiptImages = async (data) => {
        let res = APIService.get(`${Apis.Get_Receipt_Images}?campaign_id=${data?.campaign_id}&supplier_id=${data?.supplier_id}`);
        if (res.status == 200)
            return res.data;
        else
            SweetAlert(Labels.Error, 'error');
    }

    const postReceiptImages = async (file) => {
        let res = await APIService.post(`v0/ui/website/hashtag-images/${CampaignProposalId}/${Apis.Post_Receipt_Images}`, file, true);
        if (res.status == 200)
            SweetAlert(Labels.Upload_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const updateCampaignInventories = async (data) => {
        let res = await APIService.put(`/v0/ui/website/${CampaignProposalId}/campaign-inventories/`, data);
        if (res.status == 200)
            SweetAlert(res.data, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getProposalMapping = async () => {
        let res = await APIService.get(`${Apis.Get_Proposal_Centre_Mapping}?proposal_id=${CampaignProposalId}`);
        if (res.status == 200)
            return res.data;
        else
            SweetAlert(Labels.Error, 'error');
    }

    const uploadBookingPlan = async (file) => {
        let res = await APIService.post(`v0/ui/website/import-sheet-in-existing-campaign/`, file, true);
        if (res.status == 200)
            SweetAlert(Labels.Upload_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const saveSupplierPhaseList = async (data) => {
        let res = await APIService.post(`${Apis.Post_Supplier_Phase}?campaign_id=${CampaignProposalId}`, data);
        if (res.status == 200) {
            SweetAlert(Labels.Save_Success, 'success');
            getSupplierPhase();
        }
        else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const getSupplierPhase = async () => {
        let res = await APIService.get(`${Apis.Get_Supplier_Phase}?campaign_id=${CampaignProposalId}`);
        if (res.status == 200) {
            let newList = res.data.map(item => ({ ...item, label: item?.phase_no, value: item?.id }));
            setSupplierPhaseList(newList);
        }
        else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const deletSupplierPhase = async (row) => {
        let res = await APIService.delete(`${Apis.Delete_Supplier_Phase}${row?.id}/`);
        if (res.status == 200) {
            SweetAlert(Labels.Delete_Success, 'success');
            let newList = supplierPhaseList.filter(item => item.id !== row?.id);
            setSupplierPhaseList(newList);
        }
        else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const postEmailPaymentDetail = async (data) => {
        let res = await APIService.post(`${Apis.Send_Email_Payment_Detail}`, data);
        if (res.status == 200)
            SweetAlert(Labels.Email_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const updateChequeDetail = async (data) => {
        let res = APIService.post(`${Apis.Update_Cheque_Detail}`, data);
        if (res.status == 200)
            SweetAlert(Labels.Save_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const putAssignSupplierUser = async (data) => {
        let res = await APIService.put(`${Apis.Put_Assign_Supplier_User}`, data);
        if (res.status == 200)
            SweetAlert(Labels.Update_Success, 'success');
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getAreaBycity = async (city) => {
        let res = await APIService.get(`${Apis.Get_Area_By_city}${city}`);
        if (res.status == 200)
            return res?.data
        else
            SweetAlert(Labels.Error, 'error');
    }

    const getSubAreaByArea = async (area) => {
        let res = await APIService.get(`${Apis.Get_Sub_Area}${area}/?type=sub_areas`);
        if (res.status == 200) return res;
    }

    const deletInventory = async (id) => {
        let data = [id];
        let res = await APIService.post(`${Apis.Delete_Camapign_Inventory}`, data);
        if (res.status == 200) {
            SweetAlert(Labels.Delete_Success, 'success');
            let newList = campaignInventory.shortlisted_suppliers.filter((item) => item.id !== id);
            setCampaignInventory({ ...campaignInventory, shortlisted_suppliers: newList })
        } else {
            SweetAlert(Labels.Error, 'error');
        }
        return res;
    }

    const SupplierSearch = async (data) => {
        let params = "supplier_type_code=" + data?.supplier_type_code;
        params += "&supplier_center=" + data?.supplier_center;
        params += "&supplier_area=" + data?.supplier_area;
        params += "&search=" + data?.search;
        params += "&supplier_area_subarea=" + data?.supplier_area_subarea;
        params += "&proposal_id=" + data?.proposal_id
        let res = await APIService.get(`${Apis.Supplier_Search}?${params}`);
        if (res.status == 200) {
            setSupplierSearch(res?.data)
        } else {
            SweetAlert(Labels.Error, 'error');
        }
    }

    const submitSupplierList = () => {
        let filters = [];
        let center_data = {};
        let data = {};
        filtersCheckbox.map((item, index) => {
            if (item?.checked) {
                filters.push({ id: item?.value });
            }
        });
        finalSupplierList.map(async (supplier, index) => {
            let code = '';
            if (supplier.supplier_code) {
                code = supplier.supplier_code;
            }
            if (supplier.supplier_type) {
                code = supplier.supplier_type;
            }
            let supplierKeyValueData = {
                id: supplier.supplier_id,
                status: 'F',
            };
            if (!center_data[code]) {
                center_data[code] = {};
                center_data[code]['supplier_data'] = [];
                center_data[code]['filter_codes'] = filters;
            }
            if (code != null) center_data[code]['supplier_data'].push(supplierKeyValueData);
            data = {
                campaign_id: CampaignProposalId,
                center_data: center_data,
            };

            if (filters.length) {
                let res = await APIService.post(`${Apis.Post_Supplier_List}`, data);
                if (res.status == 200)
                    SweetAlert(Labels.Success, 'success');
                else
                    SweetAlert(Labels.Error, 'error');
            } else {
                SweetAlert("Atleast One Supplier and One Filter is required to Continue", 'error');
            }
        });
    }

    const getInvetoryList = async (id) => {
        let res = await APIService.get(`${Apis.Get_Inventory_List}?shortlisted_spaces_id=${id}`);
        if (res.status == 200)
            setInventoryList(res?.data);
        else
            SweetAlert(Labels.Error, 'error');
    }

    return {
        getCampaignInventories,
        getHeaderData,
        getRelationShipData,
        getContactDetailsData,
        getCommetByShortlistedId,
        postCommentByShortlistedId,
        getOrganisationList,
        getUserMinimalList,
        postBrandAssignment,
        postSupplierAssignment,
        getPermissionBoxImages,
        postPermissionBoxImages,
        getReceiptImages,
        postReceiptImages,
        getSupplierPhase,
        getBookingStatus,
        updateCampaignInventories,
        uploadBookingPlan,
        saveSupplierPhaseList,
        deletSupplierPhase,
        postEmailPaymentDetail,
        getProposalMapping,
        updateChequeDetail,
        putAssignSupplierUser,
        getAreaBycity,
        getSubAreaByArea,
        SupplierSearch,
        submitSupplierList,
        deletInventory,
        getInvetoryList,
        deletContact
    };
}
export { BookinPlanActions };